import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { MiniArticleCard } from 'data/global/types';
import { MiniArticleCards } from 'components/Grids/MiniArticleCards/MiniArticleCards';

type Props = {
  articles: MiniArticleCard[];
};

export const RelatedArticles = ({ articles }: Props) => {
  return (
    <Outer>
      <Heading>Related articles</Heading>
      <MiniArticleCards articles={articles} />
    </Outer>
  );
};

const Outer = styled.section`
  display: grid;
  grid-row-gap: 30px;
  padding: 0 20px;
  place-items: baseline;
  ${mediaQueries.desktop} {
    grid-row-gap: 40px;
    place-items: center;
  }
`;

const Heading = styled.h2`
  font-size: 20px;
  font-weight: 800;
`;
